import React, { useState, useEffect } from 'react';
import { Box, TextField, Divider } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles'
import { OTH_OTHERS_ID } from '../../../comm/constant'

const useStyles = makeStyles(() => ({
  TextField: {
    height: '3.5rem',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'gray',
      backgroundColor: '#fafafa',
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
      '& fieldset': {
        borderColor: 'lightgray',
      },
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 3,
      backgroundColor: '#ffffff',
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '1rem',
      padding: '13px 14px'
    }
  }
}))

const SortableListForm = ({
  arr1,
  currentValue,
  setValue,
  disabled,
  row,
  maxLength = 40,
  languageCode,
}) => {
  const [clickedIndexes, setClickedIndexes] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const classes = useStyles()


  useEffect(() => {
    if (Array.isArray(currentValue)) {
      const newClickedIndexes = currentValue.slice(0, -1).map(Number);
      const newInputValue = currentValue.at(-1) || '';
      setClickedIndexes(newClickedIndexes);
      setInputValue(newInputValue);
    }
  }, [currentValue]);

  const handleBoxClick = (index) => {
    const newClickedIndexes = clickedIndexes.includes(index)
      ? clickedIndexes.filter((i) => i !== index)
      : [...clickedIndexes, index];

    const appreciationIndex = arr1.findIndex(item => item?.optionId === OTH_OTHERS_ID)
    const newInputValue = appreciationIndex !== index ? inputValue : ''
    setInputValue(newInputValue);

    setClickedIndexes(newClickedIndexes);
    setValue([...newClickedIndexes, newInputValue], { shouldValidate: true });
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);


    const appreciationIndex = arr1.findIndex(item => item?.optionId === OTH_OTHERS_ID);
    let newClickedIndexes = [...clickedIndexes];

    if (newValue && appreciationIndex !== -1 && !newClickedIndexes.includes(appreciationIndex)) {
      newClickedIndexes = [...newClickedIndexes, appreciationIndex];
    } else if (!newValue && appreciationIndex !== -1 && newClickedIndexes.includes(appreciationIndex)) {
      newClickedIndexes = newClickedIndexes.filter(index => index !== appreciationIndex);
    }

    setClickedIndexes(newClickedIndexes);
    setValue([...newClickedIndexes, newValue], { shouldValidate: true });
  };

  return (
    <Box sx={{ backgroundColor: '#ffffff', padding: 2, borderRadius: 4 }}>
      {arr1.map((item, index) => (
        <React.Fragment key={item?.optionCode || index}>
          <Box
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: index === 0 ? 0 : '10px' }}
            onClick={() => handleBoxClick(index)}
          >
            <Box style={{ fontSize: '1rem' }}>{item?.[`optionDesc${languageCode}`]}</Box>
            <Box
              style={{
                width: 30,
                height: 30,
                backgroundColor: clickedIndexes.includes(index) ? '#3b84fa' : '#ffffff',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                cursor: 'pointer',
                WebkitTapHighlightColor: 'transparent',
                fontWeight: '700',
                border: '1px solid #e0e0e0',
                fontSize: '1rem'
              }}
            >
              {clickedIndexes.includes(index) ? clickedIndexes.indexOf(index) + 1 : ''}
            </Box>
          </Box>
          {item?.optionId === OTH_OTHERS_ID && (
            <TextField
              variant="outlined"
              value={inputValue}
              multiline={row ? true : false}
              placeholder="Please input"
              onChange={handleInputChange}
              rows={row}
              fullWidth
              disabled={disabled}
              style={{
                paddingTop: '10px'
              }}
              inputProps={{
                maxLength,
              }}
              className={classes.TextField}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !row) {
                  e.preventDefault();
                  e.target.blur();
                }
              }}
              autoComplete="off"
            />
          )}
          {index !== arr1.length - 1 && (
            <Divider style={{ marginTop: '5px' }} />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default SortableListForm;
